import React from 'react';
import { Link } from 'react-router-dom';
import { TbReportAnalytics } from "react-icons/tb";
import {
  BsPeople,
  BsClockHistory,
  BsFileEarmarkPerson,
  BsCreditCard
} from "react-icons/bs";

const DashboardPage = () => {

  const cards = [
    { title: "Active Employee", icon: <BsPeople />, link: "/client_dashboard/active-employee" },
    { title: "Attendence", icon: <BsClockHistory />, link: "/client_dashboard/attendance" },
    { title: "Leave Management", icon: <BsPeople />, link: "/client_dashboard/leave-management" },
    { title: "Report", icon: <TbReportAnalytics />, link: "/client_dashboard/report" },
    { title: "Offer Letter", icon: <BsCreditCard />, link: "/client_dashboard/offer-letter" },
    { title: "Appointment Letter", icon: <BsFileEarmarkPerson />, link: "/client_dashboard/appointment-letter" },
    { title: "Pay Slip", icon: <BsFileEarmarkPerson />, link: "/client_dashboard/pay-slip" },
  ];

  return (
    <div>
        <main className="py-6 bg-surface-secondary">
            <div className="container-fluid">
                {/* <!-- Card stats --> */}
                <div className="row g-6 mb-6">
                    {cards.map((card, idx) => (
                      <div className="col-xl-3 col-sm-6 col-12 py-3" key={idx}>
                        <Link to={card.link || "#"} className="text-decoration-none text-reset">
                          <div className="card shadow border-0" role="button">
                            <div className="card-body">
                              <div className="row">
                                <div className="col">
                                  <span className="h6 font-semibold text-muted text-sm d-block mb-2">{card.title}</span>
                                </div>
                                <div className="col-auto">
                                  <div className="icon icon-shape text-white text-lg rounded-circle" id='icon_shape'>
                                    {card.icon}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                </div>
            </div>
        </main>
    </div>
  )
}

export default DashboardPage;
